import { RelicsToken } from '@apeiron/planet'
import { NextImage } from '@apeiron/temp'
import { Box, styled, Tooltip, TooltipProps } from '@mui/material'
import React from 'react'

const TOTAL_RELICS_TOKEN_SLOT = 10

const Container = styled(Box)`
  display: grid;
  grid-template-columns: repeat(5, auto);
  grid-gap: 8px;
  max-width: 265px;
`

const Square = styled(Box)`
  width: 44px;
  height: 44px;
  border: 2px solid transparent;
  border-radius: 2px;
  background-image: linear-gradient(#161819, #161819),
    linear-gradient(#d2d4d6, #80807e, #d8dadc, #41474c, #9ea0a2);
  background-origin: border-box;
  background-clip: content-box, border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  &.empty {
    border: 1px solid rgba(0, 0, 0, 0.6);
  }
`

const TextTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} componentsProps={{ tooltip: { className } }} />
))`
  font-size: 12px;
  font-weight: 400;
  color: '#FFFFFF';
  background-color: #696c6e;
  padding: 8px 12px;
`

const TooltipName = styled(Box)`
  font-size: 16px;
  color: #ffffff;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 5px;
`

const ToolTipDescription = styled(Box)`
  font-size: 12px;
  color: #ffffff;
  font-weight: 400;
  line-height: 14px;
`

const RelicImage = styled(NextImage)`
  aspect-ratio: 1;

  width: 31px;
`

const RelicsToolTipTitle: React.FC<RelicsToolTipTitleProps> = props => {
  const { name, description } = props

  return (
    <>
      <TooltipName>{name}</TooltipName>
      <ToolTipDescription>{description}</ToolTipDescription>
    </>
  )
}

export const RelicsTokenView: React.FC<RelicsTokenViewProps> = props => {
  const { className, relicsTokens, relicsSlot } = props

  const relicSlotCount = relicsSlot || TOTAL_RELICS_TOKEN_SLOT

  const emptySlotCount = relicSlotCount - relicsTokens.length

  return (
    <Container className={className}>
      {relicsTokens.map(token => {
        return (
          <Square key={token.id} className='Custom-Token-Container'>
            <TextTooltip
              title={
                <RelicsToolTipTitle
                  name={token.name}
                  description={token.description}
                />
              }
            >
              <Box>
                <RelicImage
                  src={token.thumbnail}
                  alt={token.name}
                  className='Custom-Image'
                />
              </Box>
            </TextTooltip>
          </Square>
        )
      })}
      {emptySlotCount > 0 &&
        Array(emptySlotCount)
          .fill(0)
          .map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Square key={i} className='empty Custom-Token-Container' />
          ))}
    </Container>
  )
}

export type RelicsTokenViewProps = {
  className?: string
  relicsTokens: RelicsToken[]
  relicsSlot?: number
}

type RelicsToolTipTitleProps = {
  name: string
  description: string
}
